import * as React from 'react'

import { KEY_POSITIONS } from './constants'
import Sketch from './Sketch'

const getSketch = (width: number, height: number) => (p: any) => {
  let previousPosition: { x: number, y: number } = { x: width / 2, y: height / 2 }
  // For Perlin noise
  let xoff = p.random(0, 5000)
  let yoff = p.random(10000, 15000)
  let zoff = p.random(20000, 25000)
  const stepSize = 0.05

  p.setup = () => {
    p.createCanvas(width, height)
    p.stroke('white')
  }

  p.keyTyped = () => {
    const position = KEY_POSITIONS[p.key.toLowerCase()]
    if (position) {
      const maxDistanceX = width / 10
      const maxDistanceY = height / 10
      const movementX = position.x - 0.5
      const movementY = position.y - 0.5
      const xAfterMovement = previousPosition.x + maxDistanceX * movementX
      const yAfterMovement = previousPosition.y + maxDistanceY * movementY

      // Make sure we don't go off the screen
      const x = Math.min(Math.max(xAfterMovement, 0), width)
      const y = Math.min(Math.max(yAfterMovement, 0), height)

      const r = p.noise(xoff) * 255
      const g = p.noise(yoff) * 255
      const b = p.noise(zoff) * 255

      p.stroke(r, g, b)
      p.strokeWeight(3)
      p.line(previousPosition.x, previousPosition.y, x, y)

      previousPosition = { x, y }
      xoff += stepSize
      yoff += stepSize
      zoff += stepSize
    }
  }
}

const prompt = 'Draw with your keyboard'

const Draw = () => <Sketch getSketch={getSketch} prompt={prompt} />

export default Draw



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Draw.tsx